import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { HttpClient } from "@angular/common/http";
import { Observable, BehaviorSubject } from "rxjs";
import { map, tap } from "rxjs/operators";
import { Discipline } from '../models/models.lib';
import { APP_CONFIG } from '../setup/config';
import { environment } from '../../environments/environment';

const { apiUrl } = environment;

export abstract class CasiDisciplineService extends BehaviorSubject<Array<any>>{
  public loading: boolean = false;

  constructor(
    private http: HttpClient,
  ) {
    super([]);
  }

  public query(): void {
    this.fetch().subscribe((x) => {
      return super.next(x);
    });
  }

  protected fetch(): Observable<Discipline[]> {
    this.loading = true;

    return this.http.get(encodeURI(`${apiUrl}/discipline/all`))
      .pipe(
        map((response: any, i) => {
          return <Discipline[]>response;
        }),
        map(r => r.map(x => Discipline.create(x))),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class DisciplineService extends CasiDisciplineService {

  constructor(
    http: HttpClient,
    private apiService: ApiService
  ) {
    super(http)
  }

  get() {
    return this.apiService.getHttpCall('discipline/all', 'get');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('discipline', p, 'add');
  }

  update(id: number, dataItem: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`discipline/${id}`, dataItem , 'update');
  }

  // setAcive(id: number, completed: boolean): Promise<any> {
  //   return this.apiService.putHttpCallAsPromise(`discipline/${id}`, { completed }, 'update');
  // }
}
